// SM/React/src/config/environment.ts
interface EnvironmentConfig {
  apiBaseUrl: string;
  turbosendUrl: string;
  refreshUrl: string;
  paymentCallbackUrl: string;
}

interface ConfigMap {
  [key: string]: EnvironmentConfig;
}

const environmentConfigs: ConfigMap = {
  dev: {
    // apiBaseUrl: 'http://localhost:4000',
    apiBaseUrl: 'https://sm-api-dev.thekenverse.com',
    turbosendUrl: 'https://turbosend-dev-bam-api.turboverse.co/',
    refreshUrl: 'https://sm-api-dev.thekenverse.com/v1/auth/verify/refreshToken',
    paymentCallbackUrl: 'https://in5-unified-portal-react-dev.thekenverse.com/v1/payment/capture/payment',
  },
  qa: {
    apiBaseUrl: 'https://sm-api-qa.thekenverse.com',
    // apiBaseUrl: 'http://localhost:4000',
    turbosendUrl: 'https://turbosend-dev-bam-api.turboverse.co/',
    refreshUrl: 'https://sm-api-qa.thekenverse.com/v1/auth/verify/refreshToken',
    // refreshUrl: 'http://localhost:4000',
    paymentCallbackUrl: 'https://in5-unified-portal-react-qa.thekenverse.com/v1/payment/capture/payment',
  },
  uat: {
    apiBaseUrl: 'https://sm-api-uat.thekenverse.com',
    turbosendUrl: 'https://turbosend-dev-bam-api.turboverse.co/',
    refreshUrl: 'https://sm-api-uat.thekenverse.com/v1/auth/verify/refreshToken',
    paymentCallbackUrl: 'https://in5-unified-portal-react-uat.thekenverse.com/v1/payment/capture/payment',
  },
  master: {
    apiBaseUrl: 'https://sm-api-preprod.ken42.com',
    turbosendUrl: 'https://turbosend-dev-bam-api.turboverse.co/',
    refreshUrl: 'https://sm-api-preprod.ken42.com/v1/auth/verify/refreshToken',
    paymentCallbackUrl: 'https://sm-portal-preprod.ken42.com/v1/payment/capture/payment',
  },
};

const getEnvironment = (): any => {
  console.log(process.env.REACT_APP_ENVIRONMENT, 'process.env.REACT_APP_ENVIRONMENT');
  return process.env.REACT_APP_ENVIRONMENT;
};

const getCurrentConfig = (): EnvironmentConfig => {
  const environment = getEnvironment();
  const config = environmentConfigs[environment];

  if (!config) {
    console.warn(`Environment "${environment}" not found, falling back to dev`);
    return config;
  }

  return config;
};

export const config = getCurrentConfig();
export const environment = getEnvironment();

const environmentModule = {
  config,
  environment,
  getEnvironment,
  getCurrentConfig,
};

export default environmentModule;
